module.exports = __webpack_public_path__ + "static/3-eab0a7cd87f1bb3a15bcfaa94fc58ad9.jpg";